/*
 * Shell footer display type chooser
 */


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *
 *  This control is not in use.  We are keeping it around to aid styling/building future applications
 *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

rs.module("controls/development/footer-chooser", 
    
    ["layouts/site-shell", "ui/framework/client-templates"],

    function (shell, clientTemplates) {

        // Initialize the control
        function initialize(_containerJsSelector, radioJsSelector, lineTemplateKey) {

            var formContainer = $.js(_containerJsSelector);

            for (var displayType of shell.footerDisplayTypes) {

                var element = $(clientTemplates.render(lineTemplateKey,
                    {
                        "footerDisplayType": displayType,
                        "footerDisplayName": _getDisplayName(displayType),
                        "isCurrent": shell.footerDisplay == displayType
                    }));

                formContainer.append(element);
            }

            formContainer.js(radioJsSelector, { multiple: true }).on("click", function () {
                shell.footerDisplay = this.value;
            });
        }

        // Take the codified displayType and make it more pretty to display
        function _getDisplayName(displayType) {
            var display = displayType.replace("-", " ");

            return display[0].toUpperCase() + display.substr(1);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);